import React from "react";

import ReactHtmlParser from "react-html-parser";

import { ProgressSpinner } from "primereact/progressspinner";

import * as S from "./styles";

import IProps from "./props";

const Contract: React.FC<IProps> = ({ loading, data, handleSubmit }) => (
  <S.Container>
    <S.Content>
      <S.Title>Contrato de Adesão:</S.Title>
      {!data && <ProgressSpinner />}
      <S.Text>{ReactHtmlParser(data)}</S.Text>
    </S.Content>
    <S.Button onClick={handleSubmit} type="button">
      {loading ? "Enviando" : "Aceitar e concluir cadastro"}
    </S.Button>
  </S.Container>
);
export default Contract;
